import { Events } from '@platform/client';
import { Modal } from '@platform/components';
import { useQueryClient } from '@tanstack/react-query';

interface DeleteEventModalProps {
  isOpen: boolean;
  onClose: () => void;
  id: number;
  page: number;
  limit: number;
}

export const DeleteEventModal = (props: DeleteEventModalProps) => {
  const { isOpen, onClose, id, page, limit } = props;

  const queryClient = useQueryClient();

  const submitEvent = Events.useDeleteEvent({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [...Events.getGetEventsAdminQueryKey({ page, limit })],
        });
      },
    },
  });

  const deleteEvent = async () => {
    submitEvent.mutate({
      data: {
        id,
      },
    });

    closeModal();
  };

  const closeModal = () => {
    onClose();
  };

  return (
    <Modal
      variant='dialog'
      title='Delete Event'
      ignoreExtraPadding={true}
      isOpen={isOpen}
      headerDivision='divider'
      onClose={closeModal}
      primaryCTA={{
        text: 'Delete Event',
        callback: deleteEvent,
      }}
      secondaryCTA={{
        text: 'Cancel',
        callback: closeModal,
      }}
    >
      <div className='md:w-[460px]'>
        <div className='flex flex-col gap-4 w-full'>
          Are you sure you want to delete this event?
        </div>
      </div>
    </Modal>
  );
};
